import fetch from 'isomorphic-fetch'
import { RSAA } from 'redux-api-middleware'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'

import { REQUEST_PAYMENT_INTENT, RECEIVE_PAYMENT_INTENT, ERROR_PAYMENT_INTENT } from './types'

const PAYMENT_SERVICE_URL = getEnv(Env.PaymentServiceUrl)

export type PaymentIntent = (id: string) => Record<typeof RSAA, any>

export const createPaymentIntent: PaymentIntent = (id: string) => {
  return {
    [RSAA]: {
      endpoint: `${PAYMENT_SERVICE_URL}/create-payment-intent`,
      method: 'POST',
      body: JSON.stringify({
        id,
      }),
      fetch,
      types: [REQUEST_PAYMENT_INTENT, RECEIVE_PAYMENT_INTENT, ERROR_PAYMENT_INTENT],
    },
  }
}
